import React from 'react';
import CallToAction from '../components/Misc/CallToAction';
import Heading from '../components/Headers/Heading';
import ProjectsContent from '../components/ProjectComponents/ProjectsContent';

import Art from '../components/Misc/Art';
import art from '../assets/images/art_3.png';

function OurWork() {
    return (
        <div className="our-work-page">
            <Heading 
                    heading={<h1>Our Work</h1>}
                    headingClass="heading-very-large dark-1"
                    paragraph="Our solutions are used by teams worldwide to support safer, more effective, and more engaging learning."
                    paragraphClass="dark-2"
                    WrapperComponent={(props) => {
                        return (
                            <div className="page-header">
                                <div className="page-header-top">
                                    <div className="container">
                                        {props.children}
                                    </div>
                                </div>
                            </div>
                        )
                    }}
                />
            <div className="projects">
                <div className="projects-wrapper">
                    <ProjectsContent load="true" />
                </div>
            </div>
            {/*<Testimonial type="5" />*/}
            <CallToAction 
                wrapperClass='bg-main'
                heading={
    <span style={{ color: "#fff" }}>
      Have an idea?
      <br />
      Let’s explore it together.
    </span>
  }
                buttonText="Contact Us"
                buttonLink="/Contact"
                buttonType="2"
                artwork={<Art art={art} type={'4'} />}
            />
        </div>
    );
}

export default OurWork;
